import { IM, LaborTrackingRoutes, ItemDataProfileRoutes, CrateProfileRoutes, ChargeProfileRoutes, TransManagementProfileRoutes, RateScheduleProfileRoutes } from "./constants";

const WM = "Warehouse Management";
const SO = "Sow Order Database";
const TM = "Orchard Management";
const ART = "Advanced Reporting Tool";
const DD = "Dock Door Scheduler";
const PTR = "Pull Tag Review";
const IMPT = "Import/Export Data";
const Security = "Security";
const Dashboard = "Dashboard";
const DashboardLite = "Dashboard Lite";
const OrderManagement = "Order Management";
const RF = "Radio Frequency";
const TA = "Task Agent";
const InventoryManagement = "Inventory Management";
const AI = "AI Assistant";
const AR = "Accounts Receivable";
const FreightManagement = "Freight Management";

const ungroupedRoutesData = [{
    key: ART,
    name: "Advanced Reporting Tool",
    value: "/at/advancedreporttool",
},
{
    key: ART,
    name: "Configuration",
    value: "/at/configuration",
},
{
    key: Dashboard,
    name: "Design Dashboard",
    value: "/db/ManageDashboard",
},
{
    key: Dashboard,
    name: "ViewDashboard",
    value: "/db/ViewDashboard",
},
{
    key: Dashboard,
    name: "Manage Datasource",
    value: "/db/searchdatasource",
},
{
    key: Dashboard,
    name: "Manage Datasource",
    value: "/db/deletedatasource",
},
{
    key: Dashboard,
    name: "Configure Datasource",
    value: "/db/datasourceconfiguration",
},
{
    key: Dashboard,
    name: "Configure Dashboard",
    value: "/db/dashboardconfiguration",
},
{
    key: DashboardLite,
    name: "Manage",
    value: "/dbl/management",
},
{
    key: DashboardLite,
    name: "Manage",
    value: "/dbl/delete-dashboard",
},
{
    key: DashboardLite,
    name: "Configuration",
    value: "/dbl/configuration",
},

{
    key: DD,
    name: "Selection",
    value: "/wm/dockdoorselection",
}, {
    key: DD,
    name: "Status",
    value: "/wm/dockdoorstatus",
}, { 
    key: WM,
    name: "Customer -> Transactions",
    value: "/wm/transaction",
},
{
    key: WM,
    name: "Customer -> mockupv1",
    value: "/wm/mockupv1",
},
{
    key: WM,
    name: "Customer -> mockupv2",
    value: "/wm/mockupv2",
},
{
    key: WM,
    name: "Customer -> mockupv3",
    value: "/wm/mockupv3",
} , {
    key: WM,
    name: "Customer -> History",
    value: "/wm/history",
}, {
    key: WM,
    name: "Customer -> Inventory Items",
    value: "/wm/inventory-items",
}, {
    key: WM,
    name: "Customer -> Ownership Transfer",
    value: "/wm/ownershiptransfer",
}, {
    key: WM,
    name: "Transactions -> Internal Ownership Transfer",
    value: "/wm/internalownershiptransfer",
}, {
    key: WM,
    name: "Transactions -> Transfer Lots to Different Items",
    value: "/wm/transferlotstodifferentitems",
}, {
    key: WM,
    name: "Transactions -> Transfer Sublots to Different Items",
    value: "/wm/transfersublotstodifferentitems",
}, {
    key: WM,
    name: "Transactions -> Move Sublot Inventory",
    value: "/wm/move-sublot-inventory",
}, {
    key: WM,
    name: "Transactions -> Transaction Data Entry",
    value: "/wm/transactiondataentry",
},
 {
    key: WM,
    name: "Carrier -> Scheduling",
    value: "/wm/scheduling",
}, {
    key: WM,
    name: "Location Tracking -> Adjust Available Unavailable Status",
    value: "/wm/adjustavailableunavailablestatus",
}, {
    key: WM,
    name: "Location Tracking -> Map",
    value: "/wm/warehouse/map",
}, {
    key: WM,
    name: "Labor Tracking -> Enter Labor Tracking",
    value: LaborTrackingRoutes.List,
}, {
    key: WM,
    name: "Periodic Task -> Import Data",
    value: "/wm/importdata",
},
{
    key: WM,
    name: "Physical Count -> Enter Count Results",
    value: "/wm/enter-count-results",
},
{
    key: WM,
    name: "Physical Count -> Generate Count Adjustments",
    value: "/wm/generate-count-adjustments",
},
{
    key: WM,
    name: "Physical Count -> Generate Count Records",
    value: "/wm/genneratecountrecords",
},
{
    key: WM,
    name: "Transactions -> Commit Transactions To Inventory",
    value: "/wm/CommitTransactions",
},
{
    key: WM,
    name: "Transactions -> Charges -> Generate Storage Charges",
    value: "/wm/transactions/charges/generate-storage-charges",
},
{
    key: WM,
    name: "Transactions -> Update Transactions Stage",
    value: "/wm/UpdateTransactionsStage",
},
{
    key: WM,
    name: "Transactions -> Uncommit Transactions",
    value: "/wm/uncommittransactions",
},
{
    key: WM,
    name: "Transactions -> Transaction Management",
    value: "/wm/transactionmanagement",
},
{
    key: WM,
    name: "Transactions -> Schedules Management",
    value: "/wm/schedulesmanagement",
},
{
    key: WM,
    name: "Invoicing -> Commit Invoices",
    value: "/wm/commitinvoices",
},
{
    key: WM,
    name: "Invoicing -> Undo Invoices",
    value: "/wm/undoinvoices",
},
{
    key: WM,
    name: "Invoicing -> Generate Invoices",
    value: "/wm/generateinvoices",
},
{
    key: WM,
    name: "Invoicing -> Update Invoices",
    value: "/wm/searchinvoices",
},
{
    key: WM,
    name: "Reports -> Location Tracking -> Empty Locations Report",
    value: "/wm/reports/WMR0063",
},
{
    key: WM,
    name: "Reports -> Item Codes -> Item Serial Number Report",
    value: "/wm/reports/WMR0064",
},
{
    key: WM,
    name: "Reports -> Transactions -> Schedule Report",
    value: "/wm/reports/WMR0065",
},
{
    key: WM,
    name: "Reports -> Inventory -> SubLot Codes Report",
    value: "/wm/reports/WMR0066",
},
{
    key: WM,
    name: "Reports -> Inventory -> Available Locations Report",
    value: "/wm/reports/WMR0067",
},
{
    key: WM,
    name: "Reports -> Crate Codes -> Crate Report",
    value: "/wm/reports/WMR0068",
},
{
    key: WM,
    name: "Codes -> Warehouse Exceptions",
    value: "/wm/codes/exceptions",
},
{
    key: WM,
    name: "Data Profiles -> Item Data Profile Data Entry",
    value: ItemDataProfileRoutes.List,
},
{
    key: WM,
    name: "Data Profiles -> Item Data Profile Data Entry -> Add Item Data Profile",
    value: ItemDataProfileRoutes.Create,
},
{
    key: WM,
    name: "Data Profiles -> Item Data Profile Data Entry -> Edit Item Data Profile",
    value: ItemDataProfileRoutes.Edit,
},
{
    key: WM,
    name: "Data Profiles -> Enter Crate Profiles",
    value: CrateProfileRoutes.List,
},
{
    key: WM,
    name: "Data Profiles -> Enter Crate Profiles -> Add Crate Profile",
    value: CrateProfileRoutes.Create,
},
{
    key: WM,
    name: "Data Profiles -> Enter Crate Profiles -> Edit Crate Profile",
    value: CrateProfileRoutes.Edit,
},
{
    key: WM,
    name: "Data Profiles -> Enter Charge Profiles",
    value: ChargeProfileRoutes.List,
},
{
    key: WM,
    name: "Data Profiles -> Enter Charge Profiles -> Add Charge Profile",
    value: ChargeProfileRoutes.Create,
},
{
    key: WM,
    name: "Data Profiles -> Enter Charge Profiles -> Edit Charge Profile",
    value: ChargeProfileRoutes.Edit,
},
{
    key: WM,
    name: "Data Profiles -> Enter Rate Schedule Profiles",
    value: RateScheduleProfileRoutes.List,
},
{
    key: WM,
    name: "Data Profiles -> Enter Rate Schedule Profiles -> Add Rate Schedule Profile",
    value: RateScheduleProfileRoutes.Create,
},
{
    key: WM,
    name: "Data Profiles -> Enter Rate Schedule Profiles -> Edit Rate Schedule Profile",
    value: RateScheduleProfileRoutes.Edit,
},
{
    key: WM,
    name: "Codes -> Warehouse Exceptions -> Add Warehouse Exception",
    value: "/wm/codes/add-exception",
},
{
    key: WM,
    name: "Codes -> Warehouse Exceptions -> Edit Warehouse Exception",
    value: "/wm/codes/edit-exception",
},
{
    key: WM,
    name: "Charges -> Search Charges",
    value: "/wm/charges/search-charges",
},
{
    key: WM,
    name: "Charges -> Calculate Deferred Handling Revenue",
    value: "/wm/charges/calculate-deferred-handling-revenue",
},
{
    key: WM,
    name: "Charges -> Update Free Days and Grace Periods",
    value: "/wm/charges/update-free-days-grace-periods",
},
{
    key: WM,
    name: "Charges -> Generate Repeating Misc Charges",
    value: "/wm/charges/generate-repeating-misc-charges",
},
{
    key: WM,
    name: "Delivery Management -> Transfer Shipments To Dispatch",
    value: "/wm/delivery-management/transfer-shipments-to-dispatch",
},
{
    key: WM,
    name: "Periodic Tasks -> Item Codes -> Purge Never Used Items, Lots and Sublots",
    value: "/wm/periodic-tasks/item-codes/purge-never-used-records",
},
{
    key: WM,
    name: "Periodic Tasks -> Item Codes -> Set Unused Lots To Inactive Status",
    value: "/wm/periodic-tasks/item-codes/set-unused-lots-inactive",
},
{
    key: WM,
    name: "Periodic Tasks -> Transactions -> Delete Item Tasks",
    value: "/wm/periodic-tasks/transactions/delete-item-tasks",
},
{
    key: SO,
    name: "PU Processing -> Review Records",
    value: "/so/review-records",
},
{
    key: SO,
    name: "PU Processing -> Lot Select",
    value: "/so/lot-select",
},
{
    key: SO,
    name: "PU Processing -> Master Records",
    value: "/so/master-records",
},
{
    key: SO,
    name: "PU Processing -> Pull Order",
    value: "/so/pullorder",
}, {
    key: SO,
    name: "PU Processing -> Select Dry Strat",
    value: "/so/dry-strat",
},
{
    key: SO,
    name: "PU Processing -> Strat Complete",
    value: "/so/strat-complete",
},
{
    key: SO,
    name: "PU Processing -> Ship",
    value: "/so/ship-complete",
},
{
    key: SO,
    name: "Calculators -> Bare Root",
    value: "/so/bare-root",
},
{
    key: SO,
    name: "Calculators -> Plugs",
    value: "/so/plugs",
},
{
    key: TM,
    name: "Transactions -> Inspection Sheet",
    value: "/tm/transactions/inspection",
},
{
    key: TM,
    name: "Transactions -> Import Inspections",
    value: "/tm/transactions/importinspections",
},
{
    key: TM,
    name: "Transactions -> Export Inspections",
    value: "/tm/transactions/exportinspections",
},
{
    key: TM,
    name: "Transactions -> Print Asset Tags",
    value: "/tm/transactions/printassettags",
},
{
    key: TM,
    name: "Transactions -> Inspection Types",
    value: "/tm/transactions/inspectiontypes",
},
{
    key: TM,
    name: "Reports -> Inventory Reports",
    value: "/tm/reports/inventoryreports",
},
{
    key: TM,
    name: "Codes -> Orchard Codes",
    value: "/tm/codes/orchard-codes",
},
{
    key: TM,
    name: "Codes -> Block Codes",
    value: "/tm/codes/block-codes",
},
{
    key: TM,
    name: "Codes -> Location Codes",
    value: "/tm/codes/location-codes",
},
{
    key: TM,
    name: "Codes -> Ramet Codes",
    value: "/tm/codes/ramet-codes",
},
{
    key: OrderManagement,
    name: "Customer -> Transaction",
    value: "/om/transaction",
} ,
{
    key: OrderManagement,
    name: "Customer -> History",
    value: "/om/history",
},
{
    key: OrderManagement,
    name: "Reports -> Sales Orders -> Query Orders By Customer",
    value: "/om/reports/query-orders-by-customer",
},
{
    key: OrderManagement,
    name: "Customer -> Inventory Items",
    value: "/om/Inventory",
},
{
    key: OrderManagement,
    name: "Transactions -> Commit Transactions",
    value: "/om/omcommittransaction",
},
{
    key: OrderManagement,
    name: "Transactions -> Commit Transactions -> Pre-Commit Transaction to AC",
    value: "/om/omprecommittransaction",
},
{
    key: OrderManagement,
    name: "Transactions -> Allocate Available Quantities",
    value: "/om/AllocateAvailableQuantities",
},
{
    key: OrderManagement,
    name: "Transactions -> Sales Order Data Entry",
    value: "/om/transactions/salesorders/salesorder-data-entry",
},
{
    key: OrderManagement,
    name: "Transactions -> Sales Order Management",
    value: "/om/SalesOrderManagement",
},
{
    key: OrderManagement,
    name: "Transactions -> Replicate Orders",
    value: "/om/replicateomtransaction",
},
{
    key: OrderManagement,
    name: "Reports -> Sales order Edit Report",
    value: "/om/reports/OMR0011",
},
{
    key: OrderManagement,
    name: "Reports -> Order Acknowledgment Report",
    value: "/om/reports/OMR0003",
},
{
    key: OrderManagement,
    name: "Reports -> Item Availability Report",
    value: "/om/reports/OMR0012",
},
{
    key: OrderManagement,
    name: "Reports -> Invoice Report",
    value: "/om/reports/OMR0004",
},
{
    key: OrderManagement,
    name: "Reports -> Consolidated Picking Slip - Mckay",
    value: "/om/reports/OMR0042",
},
{
    key: OrderManagement,
    name: "Reports -> Consignment Items Recap Report",
    value: "/om/reports/OMR0043",
},
{
    key: OrderManagement,
    name: "Reports -> Packing Slip - Serial #",
    value: "/om/reports/OMR0044",
},
{
    key: OrderManagement,
    name: "Transactions -> Generate Count Records",
    value: "/om/genneratecountrecords",
},
{
    key: OrderManagement,
    name: "Customer -> Inventory Lots",
    value: "/om/inventory-lots",
},
{
    key: OrderManagement,
    name: "Customer -> Dynamic Form",
    value: "/om/dynamic-form",
},
{
    key: OrderManagement,
    name: "Setup",
    value: "/om/setup",
},

{
    key: PTR,
    name: "Dashboard",
    value: "/ptr/LoadIframe/DashboardManagement",
},
{
    key: PTR,
    name: "Early Tag Report",
    value: "/ptr/LoadIframe/EarlyTagReport",
},
{
    key: PTR,
    name: "Daily Updates",
    value: "/ptr/LoadIframe/DailyUpdates",
},
{
    key: PTR,
    name: "Daily Updates(BETA)",
    value: "/ptr/LoadIframe/DailyUpdates2",
},
{
    key: PTR,
    name: "Master Codes",
    value: "/ptr/LoadIframe/Configuration",
},
{
    key: PTR,
    name: "Group Overrides",
    value: "//ptr/LoadIframe/Overrides",
},
{
    key: PTR,
    name: "Attributes",
    value: "/ptr/LoadIframe/Attributes",
},
{
    key: PTR,
    name: "Rules",
    value: "/ptr/LoadIframe/Rules",
},
{
    key: PTR,
    name: "Crop Roll Tool",
    value: "/ptr/LoadIframe/CropRollTool",
},
{
    key: IMPT,
    name: "XM Monitor",
    value: "/xm/xm-monitor",
},
{
    key: Security,
    name: "Change Password",
    value: "/security/change-password",
},
{
    key: Security,
    name: "Facilities",
    value: "/security/facilities",
},
{
    key: Security,
    name: "User Security",
    value: "/security/user-security",
},
{
    key: Security,
    name: "Customer Account Administration",
    value: "/security/customer-account-administration",
},
{
    key: Security,
    name: "Two Factor Authentication Settings",
    value: "/security/two-factor-settings",
},
{
    key: Security,
    name: "Application Settings",
    value: "/security/app-settings",
},
{
    key: Security,
    name: "API Audit Logs",
    value: "/security/api-audit-logs",
},
{
    key: Security,
    name: "Report Groups",
    value: "/security/report-groups",
},
{
    key: WM,
    name: "Codes -> Customer Data Entry",
    value: "/wm/codes/customer-data-entry",
},
{
    key: WM,
    name: "Codes -> Consignee Data Entry",
    value: "/wm/codes/consignee-data-entry",
},
{
    key: WM,
    name: "Codes -> Carrier Data Entry",
    value: "/wm/codes/carrier-data-entry",
},
{
    key: WM,
    name: "Codes -> Warehouse Data Entry",
    value: "/wm/codes/warehouse-data-entry",
},
{
    key: WM,
    name: "Codes -> Item Data Entry",
    value: "/wm/codes/item-data-entry",
},
{
    key: WM,
    name: "Codes -> Descriptive Codes",
    value: "/wm/codes/descriptive-codes-data-entry-list",
},
{
    key: WM,
    name: "Codes -> Warehouse Weekly Settings",
    value: "/wm/codes/week-settings",
},
{
    key: "",
    name: "Home",
    value: "/home"
},
{
    key: AI,
    name: "Chat",
    value: "/ai/chat"
},
{
    key: AI,
    name: "Vector Store Data Entry",
    value: "/ai/vectorstore-data-entry"
},
{
    key: AI,
    name: "File Data Entry",
    value: "/ai/file-data-entry"
},
{
    key: AI,
    name: "Usage Metrics",
    value: "/ai/usage-metrics"
},
{
    key: InventoryManagement,
    name: "Transactions -> Transaction Entry Form",
    value: "/im/TransactionEntryForm/TransactionEntryForm",
},
{
    key: InventoryManagement,
    name: "Transactions -> Enter Transaction",
    value: "/im/EnterTransaction/EnterTransaction",
},
{
    key: InventoryManagement,
    name: "Transactions -> Item Management",
    value: "/im/itemManagement/ItemManagement",
},
{
    key: InventoryManagement,
    name: "Transactions -> Transaction Entry Form",
    value: "/im/InventoryOperation",
},
{
    key: InventoryManagement,
    name: "Enter Location Code",
    value: "/im/SearhLocationCode/EnterLocationCode",
},
{
    key: InventoryManagement,
    name: "Transactions -> Location Data Entry",
    value: "/im/codes/location-data-entry",
},
{
    // Legacy IMD0086, presented from OM => Processing. Home search filters this list, so one entry
    // per route: a duplicate would list the page twice.
    //
    // Names both folder levels, matching the sidebar path and the breadcrumb in NavigationPaths.js -
    // the two must stay identical, since a user searching Home lands on a page whose breadcrumb is
    // supposed to say where they are.
    key: OrderManagement,
    name: "Transactions -> Processing -> Recalculate Kit Usage Details",
    value: "/om/processes/recalculate-kit-usage",
},
{
    key: WM,
    name: "Codes -> Lot Data Entry",
    value: "/wm/codes/lot-data-entry",
},
{
    key: WM,
    name: "Codes -> Sublot Data Entry",
    value: "/wm/codes/sublot-data-entry",
},
{
    key: RF,
    name: "RFMessages",
    value: "/rf/periodictasks/rfmessages",
},
{
    key: WM,
    name: "Setup -> Global Setup",
    value: "/wm/setup/trans-num",
}
,
{
    key: OrderManagement,
    name: "Data Profiles -> Transaction Profile Data Entry",
    value: "/om/data-profiles/salesorder-profile-data-entry",
}
,
{
    key: WM,
    name: "Codes -> Location Data Entry",
    value: "/wm/codes/location-data-entry",
},
{
    key: WM,
    name: "Codes -> Crates Data Entry",
    value: "/wm/codes/crate-data-entry",
},
{
    key: WM,
    name: "Data Profiles -> Transaction Profile Data Entry",
    value: "/wm/DataProfiles/SearchTransactionProfiles",
},
{
    key: WM,
    name: "Data Profiles -> Enter Item Kit Profiles",
    value: "/wm/data-profiles/item-kit-profiles",
},
{
    key: WM,
    name: "Data Profiles -> Enter Item Kit Profiles -> Add",
    value: "/wm/data-profiles/add-item-kit-profile",
},
{
    key: WM,
    name: "Data Profiles -> Transaction Management Data Profile",
    value: TransManagementProfileRoutes.List,
},
{
    key: WM,
    name: "Data Profiles -> Transaction Management Data Profile -> Add Transaction Management Data Profile",
    value: TransManagementProfileRoutes.Create,
},
{
    key: WM,
    name: "Data Profiles -> Transaction Management Data Profile -> Edit Transaction Management Data Profile",
    value: TransManagementProfileRoutes.Edit,
},
{
    key: OrderManagement,
    name: "Codes -> Item Data Entry",
    value: "/om/codes/item-data-entry-list",
},
{    
    key: TA,
    name: "Task Queue",
    value: "/ta/task-queue-list",
},{
    key: OrderManagement,
    name: "Codes -> Lot Data Entry",
    value: "/om/codes/lot-data-entry-list",
},
{
    key: OrderManagement,
    name: "Transfer Deliveries To Dispatch",
    value: "/om/transactions/delivery-management/transfer-deliveries-to-dispatch",
},
{
    key: OrderManagement,
    name: "Codes -> Descriptive Codes Data Entry",
    value: "/om/codes/descriptive-codes-data-entry-list",
},
{
    key: OrderManagement,
    name: "Generate PO Drop-Ship Orders",
    value: "/om/transactions/processing/generate-po-drop-ship-orders",
},
{
    key: OrderManagement,
    name: "PO -> Generate Item Reorder Records",
    value: "/po/transactions/requisitions/generate-item-reorder-records",
},
{
    key: OrderManagement,
    name: "OM -> Transactions -> Update Order Stage",
    value: "/om/update-order-stage",
},
{
    key: AR,
    name: "Collections -> Credit/Collections Follow-up",
    value: "/ar/collections/follow-up",
},
{
    key: FreightManagement,
    name: "Freight Bills -> Send BOL",
    value: "/fm/freight-bills/send-bol",
},
{
    key: FreightManagement,
    name: "Freight Bills -> Driver BOLs",
    value: "/fm/freight-bills/driver-bols",
},
{
    // Legacy FMD0000. Only the OM path is registered: Dispatch Management is reached from the OM
    // sidebar and gated on an OM permission, so an FM entry for it would lead nowhere.
    key: OrderManagement,
    name: "Transactions -> Delivery Management -> Dispatch Management",
    value: "/om/transactions/delivery-management/dispatch-management",
},
{
    // Legacy OMD0031. Only the listing is registered: the edit route needs a trip from the listing, so
    // a Home-search entry for it would open an empty form. Same name as the sidebar and the breadcrumb
    // in NavigationPaths.js.
    key: OrderManagement,
    name: "Transactions -> Delivery Management -> Update Route/Trips on Orders",
    value: "/om/transactions/delivery-management/list",
},
]
export default ungroupedRoutesData